export default __webpack_public_path__ + "static/media/yellow-belt.f45c58d0.png";